import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import ServiceHero from './components/ServiceHero';
import ServiceCategory from './components/ServiceCategory';
import ServiceCard from './components/ServiceCard';
import PricingTable from './components/PricingTable';
import QualityGuarantees from './components/QualityGuarantees';
import Button from '../../components/ui/Button';


const ServicesOverview = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [filteredServices, setFilteredServices] = useState([]);

  const categories = [
    { id: 'all', name: 'All Services', icon: 'Package', count: 9 },
    { id: 'wash', name: 'Wash & Laundry', icon: 'Shirt', count: 2 },
    { id: 'dry-clean', name: 'Dry Cleaning', icon: 'Sparkles', count: 2 },
    { id: 'premium', name: 'Premium Care', icon: 'Crown', count: 3 },
    { id: 'specialty', name: 'Specialty Items', icon: 'Star', count: 2 }
  ];

  /* --- OLD SERVICES (12) - Commented ---
  const servicesOld = [
    {
      id: 1,
      category: 'wash',
      title: 'Wash & Fold',
      description: 'Complete washing, drying, and folding service for your everyday garments with premium detergents.',
      price: '149',
      unit: 'per kg',
      duration: '24-48 hours',
      turnaround: 'Standard',
      icon: 'Shirt',
      iconColor: 'var(--color-primary)',
      iconBg: 'bg-primary/10',
      hoverBg: 'bg-primary',
      isPopular: true,
      features: [
        'Machine wash & dry',
        'Professional folding',
        'Fabric softener included',
        'Basic stain removal'
      ]
    },
    {
      id: 2,
      category: 'wash',
      title: 'Express Wash',
      description: 'Quick turnaround washing service for urgent laundry needs with same-day delivery.',
      price: '199',
      unit: 'per kg',
      duration: '4-6 hours',
      turnaround: 'Express',
      icon: 'Zap',
      iconColor: 'var(--color-accent)',
      iconBg: 'bg-accent/10',
      hoverBg: 'bg-accent',
      isPopular: false,
      features: [
        'Same-day service',
        'Priority processing',
        'Express delivery',
        'Quality guarantee'
      ]
    },
    {
      id: 3,
      category: 'dry-clean',
      title: 'Dry Cleaning',
      description: 'Professional dry cleaning for suits, dresses, and delicate fabrics requiring special care.',
      price: '299',
      unit: 'per piece',
      duration: '48-72 hours',
      turnaround: 'Standard',
      icon: 'Sparkles',
      iconColor: 'var(--color-success)',
      iconBg: 'bg-success/10',
      hoverBg: 'bg-success',
      isPopular: false,
      features: [
        'Solvent-based cleaning',
        'Professional pressing',
        'Stain treatment',
        'Protective packaging'
      ]
    },
    {
      id: 4,
      category: 'premium',
      title: 'Premium Pressing',
      description: 'Expert pressing and finishing service for formal wear and business attire.',
      price: '99',
      unit: 'per piece',
      duration: '24 hours',
      turnaround: 'Next Day',
      icon: 'Iron',
      iconColor: 'white',
      iconBg: 'bg-accent/10',
      hoverBg: 'bg-accent',
      isPopular: false,
      features: [
        'Professional pressing',
        'Steam finishing',
        'Crease setting',
        'Hanger service'
      ]
    },
    {
      id: 5,
      category: 'specialty',
      title: 'Leather & Suede Care',
      description: 'Specialized cleaning and conditioning for leather jackets, suede items, and luxury accessories.',
      price: '599',
      unit: 'per piece',
      duration: '5-7 days',
      turnaround: 'Extended',
      icon: 'Shield',
      iconColor: 'var(--color-accent)',
      iconBg: 'bg-accent/10',
      hoverBg: 'bg-accent',
      isPopular: false,
      features: [
        'Specialized solvents',
        'Conditioning treatment',
        'Color restoration',
        'Expert handling'
      ]
    },
    {
      id: 6,
      category: 'wash',
      title: 'Delicate Wash',
      description: 'Gentle hand washing for silk, lace, and other delicate fabrics requiring special attention.',
      price: '249',
      unit: 'per piece',
      duration: '48 hours',
      turnaround: 'Standard',
      icon: 'Heart',
      iconColor: 'var(--color-success)',
      iconBg: 'bg-success/10',
      hoverBg: 'bg-success',
      isPopular: false,
      features: [
        'Hand washing',
        'pH-balanced detergent',
        'Air drying',
        'Gentle handling'
      ]
    },
    {
      id: 7,
      category: 'premium',
      title: 'Wedding Dress Care',
      description: 'Specialized cleaning and preservation service for wedding gowns and formal dresses.',
      price: '1299',
      unit: 'per dress',
      duration: '7-10 days',
      turnaround: 'Extended',
      icon: 'Crown',
      iconColor: 'var(--color-primary)',
      iconBg: 'bg-primary/10',
      hoverBg: 'bg-primary',
      isPopular: false,
      features: [
        'Museum-quality cleaning',
        'Preservation packaging',
        'Stain removal',
        'Expert restoration'
      ]
    },
    {
      id: 8,
      category: 'wash',
      title: 'Eco-Friendly Wash',
      description: 'Environmentally conscious washing using biodegradable detergents and energy-efficient processes.',
      price: '179',
      unit: 'per kg',
      duration: '24-48 hours',
      turnaround: 'Standard',
      icon: 'Leaf',
      iconColor: 'var(--color-success)',
      iconBg: 'bg-success/10',
      hoverBg: 'bg-success',
      isPopular: false,
      features: [
        'Biodegradable detergents',
        'Energy-efficient process',
        'Eco-friendly packaging',
        'Carbon-neutral delivery'
      ]
    },
    {
      id: 9,
      category: 'dry-clean',
      title: 'Curtain & Drape Cleaning',
      description: 'Professional cleaning service for curtains, drapes, and large fabric items.',
      price: '399',
      unit: 'per panel',
      duration: '3-5 days',
      turnaround: 'Extended',
      icon: 'Home',
      iconColor: 'var(--color-accent)',
      iconBg: 'bg-accent/10',
      hoverBg: 'bg-accent',
      isPopular: false,
      features: [
        'Pickup & rehang service',
        'Dust & allergen removal',
        'Fabric protection',
        'Professional handling'
      ]
    },
    {
      id: 10,
      category: 'specialty',
      title: 'Shoe Cleaning & Care',
      description: 'Complete shoe cleaning, polishing, and restoration service for all types of footwear.',
      price: '199',
      unit: 'per pair',
      duration: '48 hours',
      turnaround: 'Standard',
      icon: 'Footprints',
      iconColor: 'var(--color-primary)',
      iconBg: 'bg-primary/10',
      hoverBg: 'bg-primary',
      isPopular: false,
      features: [
        'Deep cleaning',
        'Polish & conditioning',
        'Odor treatment',
        'Minor repairs'
      ]
    },
    {
      id: 11,
      category: 'premium',
      title: 'Luxury Garment Care',
      description: 'White-glove service for designer clothing and luxury fashion items.',
      price: '499',
      unit: 'per piece',
      duration: '3-5 days',
      turnaround: 'Extended',
      icon: 'Star',
      iconColor: 'var(--color-accent)',
      iconBg: 'bg-accent/10',
      hoverBg: 'bg-accent',
      isPopular: false,
      features: [
        'Designer expertise',
        'Individual attention',
        'Premium packaging',
        'Insurance coverage'
      ]
    },
    {
      id: 12,
      category: 'dry-clean',
      title: 'Uniform Cleaning',
      description: 'Bulk cleaning service for corporate uniforms, school uniforms, and workwear.',
      price: '129',
      unit: 'per piece',
      duration: '24-48 hours',
      turnaround: 'Standard',
      icon: 'Users',
      iconColor: 'var(--color-success)',
      iconBg: 'bg-success/10',
      hoverBg: 'bg-success',
      isPopular: false,
      features: [
        'Bulk pricing available',
        'Starch options',
        'Logo preservation',
        'Regular pickup schedule'
      ]
    }
  ];
  --- End OLD SERVICES --- */

  // New 9 Services (from design)
  const services = [
    {
      id: 1,
      category: 'dry-clean',
      title: 'Dry Cleaning',
      description: 'Professional dry cleaning for suits, dresses, and delicate fabrics requiring special care.',
      price: '90',
      unit: '/ Item',
      duration: '48-72 hours',
      turnaround: 'Standard',
      icon: 'Shirt',
      iconColor: 'var(--color-success)',
      iconBg: 'bg-success/10',
      hoverBg: 'bg-success',
      isPopular: false,
      features: [
        'Solvent-based cleaning',
        'Professional pressing',
        'Stain treatment',
        'Protective packaging'
      ]
    },
    {
      id: 2,
      category: 'wash',
      title: 'Laundry Wash & Fold',
      description: 'Complete washing, drying, and folding service for your everyday garments with premium detergents.',
      price: '119',
      unit: '/ Kg',
      duration: '24-48 hours',
      turnaround: 'Standard',
      icon: 'WashingMachine',
      iconColor: 'var(--color-primary)',
      iconBg: 'bg-primary/10',
      hoverBg: 'bg-primary',
      isPopular: true,
      features: [
        'Machine wash & dry',
        'Professional folding',
        'Fabric softener included',
        'Basic stain removal'
      ]
    },
    {
      id: 3,
      category: 'wash',
      title: 'Laundry Wash & Iron',
      description: 'Wash, dry, and expert pressing service for crisp, wrinkle-free garments ready to wear.',
      price: '149',
      unit: '/ Kg',
      duration: '24-48 hours',
      turnaround: 'Standard',
      icon: 'Iron',
      iconColor: 'var(--color-primary)',
      iconBg: 'bg-primary/10',
      hoverBg: 'bg-primary',
      isPopular: false,
      features: [
        'Wash, dry & iron',
        'Steam pressing',
        'Crease-free finish',
        'Hanger-ready delivery'
      ]
    },
    {
      id: 4,
      category: 'premium',
      title: 'Steam Press',
      description: 'Expert steam pressing and finishing for fresh, crisp garments without full wash.',
      price: '20',
      unit: '/ Item',
      duration: '24 hours',
      turnaround: 'Standard',
      icon: 'Iron',
      iconColor: 'var(--color-accent)',
      iconBg: 'bg-accent/10',
      hoverBg: 'bg-accent',
      isPopular: false,
      features: [
        'Steam pressing',
        'Quick turnaround',
        'Odor refresh',
        'Ready to wear'
      ]
    },
    {
      id: 5,
      category: 'specialty',
      title: 'Toys Cleaning',
      description: 'Gentle cleaning for soft toys, plush items, and children\'s playthings with safe detergents.',
      price: '120',
      unit: '/ Item',
      duration: '48 hours',
      turnaround: 'Standard',
      icon: 'Smile',
      iconColor: 'var(--color-accent)',
      iconBg: 'bg-accent/10',
      hoverBg: 'bg-accent',
      isPopular: false,
      features: [
        'Gentle hand wash',
        'Hypoallergenic detergent',
        'Thorough drying',
        'Safe for children'
      ]
    },
    {
      id: 6,
      category: 'premium',
      title: 'Shoe Care',
      description: 'Complete shoe cleaning, polishing, and restoration for all types of footwear.',
      price: '290',
      unit: '/ Item',
      duration: '48 hours',
      turnaround: 'Standard',
      icon: 'Footprints',
      iconColor: 'var(--color-primary)',
      iconBg: 'bg-primary/10',
      hoverBg: 'bg-primary',
      isPopular: false,
      features: [
        'Deep cleaning',
        'Polish & conditioning',
        'Odor treatment',
        'Minor repairs'
      ]
    },
    {
      id: 7,
      category: 'premium',
      title: 'Leather Care',
      description: 'Specialized cleaning and conditioning for leather jackets, bags, and accessories.',
      price: '150',
      unit: '/ Item',
      duration: '5-7 days',
      turnaround: 'Extended',
      icon: 'Briefcase',
      iconColor: 'var(--color-accent)',
      iconBg: 'bg-accent/10',
      hoverBg: 'bg-accent',
      isPopular: false,
      features: [
        'Specialized solvents',
        'Conditioning treatment',
        'Color restoration',
        'Expert handling'
      ]
    },
    {
      id: 8,
      category: 'specialty',
      title: 'Carpet Cleaning',
      description: 'Professional deep cleaning for carpets and rugs with stain and allergen removal.',
      price: '40',
      unit: '/ Sq ft',
      duration: '3-5 days',
      turnaround: 'Extended',
      icon: 'LayoutGrid',
      iconColor: 'var(--color-success)',
      iconBg: 'bg-success/10',
      hoverBg: 'bg-success',
      isPopular: false,
      features: [
        'Deep extraction',
        'Stain removal',
        'Allergen treatment',
        'Fresh fragrance'
      ]
    },
    {
      id: 9,
      category: 'dry-clean',
      title: 'Curtain Cleaning',
      description: 'Professional cleaning for curtains, drapes, and large fabric window treatments.',
      price: '150',
      unit: '/ Kg',
      duration: '3-5 days',
      turnaround: 'Extended',
      icon: 'Home',
      iconColor: 'var(--color-accent)',
      iconBg: 'bg-accent/10',
      hoverBg: 'bg-accent',
      isPopular: false,
      features: [
        'Pickup & rehang',
        'Dust & allergen removal',
        'Fabric protection',
        'Professional handling'
      ]
    }
  ];

  useEffect(() => {
    if (activeCategory === 'all') {
      setFilteredServices(services);
    } else {
      setFilteredServices(services?.filter(service => service?.category === activeCategory));
    }
  }, [activeCategory]);

  return (
    <>
      <Helmet>
        <title>Services Overview - Maayo Fabric Care | Professional Laundry Services in Coimbatore</title>
        <meta name="description" content="Explore our comprehensive laundry services including wash & fold, dry cleaning, premium care, and specialty treatments. Quality guaranteed with convenient pickup & delivery in Coimbatore." />
        <meta name="keywords" content="laundry services, dry cleaning, wash fold, premium care, Coimbatore laundry, professional cleaning" />
      </Helmet>
      <div className="min-h-screen bg-background">
        <Header />

        {/* Hero Section */}
        <ServiceHero />

        {/* Main Content */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 space-y-20">

          {/* Service Categories & Grid */}
          <div className="space-y-12">
            {/* Category Filter */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
              className="text-center space-y-8"
            >
              <div>
                <h2 className="text-3xl font-bold text-foreground mb-4">
                  Our Service Categories
                </h2>
                <p className="text-muted-foreground max-w-2xl mx-auto">
                  Choose from our comprehensive range of professional laundry services, each designed to meet specific garment care needs.
                </p>
              </div>

              <div className="flex flex-col sm:flex-row sm:flex-nowrap justify-center gap-3 sm:gap-3 max-w-6xl mx-auto">
                {categories?.map((category, index) => (
                  <ServiceCategory
                    key={category?.id}
                    category={category}
                    isActive={activeCategory === category?.id}
                    onClick={setActiveCategory}
                    index={index}
                  />
                ))}
              </div>
            </motion.div>

            {/* Services Grid */}
            <motion.div
              key={activeCategory}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
              className="grid md:grid-cols-2 lg:grid-cols-3 gap-8"
            >
              {filteredServices?.map((service, index) => (
                <ServiceCard
                  key={service?.id}
                  service={service}
                  index={index}
                />
              ))}
            </motion.div>
          </div>

          {/* Pricing Section */}
          <PricingTable />

          {/* Quality Guarantees */}
          <QualityGuarantees />

          {/* Final CTA Section */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="bg-gradient-to-r from-primary to-accent rounded-3xl p-12 text-center text-white"
          >
            <div className="max-w-3xl mx-auto space-y-6">
              <h2 className="text-3xl font-bold">
                Ready to Experience Premium Laundry Care?
              </h2>
              <p className="text-xl opacity-90">
                Join thousands of satisfied customers who trust Maayo Fabric Care for their garment care needs. Schedule your first pickup today and discover the difference professional care makes.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6 pt-4">
                <Button
                  variant="secondary"
                  size="lg"
                  onClick={() => window.location.href = '/pickup-scheduling'}
                  iconName="Calendar"
                  iconPosition="right"
                  className="bg-white text-primary hover:bg-gray-100 transition-all duration-300 hover:shadow-elevation-3"
                >
                  Schedule Pickup Now
                </Button>
                <Button
                  variant="outline"
                  size="lg"
                  onClick={() => window.location.href = '/collection-points'}
                  iconName="MapPin"
                  iconPosition="left"
                  className="border-white text-white hover:bg-white hover:text-primary transition-all duration-300"
                >
                  Find Locations
                </Button>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
};

export default ServicesOverview;